import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { neutral } from '_lex/_foundations/phxColors';

export type LexCardProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  headerSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
  footerSx?: SxProps<Theme>;
};

function LexCard({ header, footer, children, sx, headerSx, contentSx, footerSx }: LexCardProps) {
  return (
    <Box
      sx={{
        border: `1px solid ${neutral[200]}`,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
    >
      {header !== undefined && (
        <Box
          sx={{
            height: 48,
            display: 'flex',
            alignItems: 'center',
            px: 2,
            ...headerSx,
          }}
        >
          {header}
        </Box>
      )}
      <Box
        sx={{
          flexShrink: 0,
          borderBottom: footer !== undefined ? `1px solid ${neutral[200]}` : undefined,
          ...contentSx,
        }}
      >
        {children}
      </Box>
      {footer !== undefined && (
        <Box
          sx={{
            height: 48,
            display: 'flex',
            alignItems: 'center',
            px: 2,
            ...footerSx,
          }}
        >
          {footer}
        </Box>
      )}
    </Box>
  );
}

export default LexCard;
